// API Services Index
// Exports all API modules for the Silk Road Terminal

// Import APIs as namespaces to avoid naming conflicts
import * as worldBank from './worldBankApi';
import * as imf from './imfApi';
import * as fx from './fxApi';
import * as cbu from './cbuApi';
import * as adb from './adbApi';
import * as unctad from './unctadApi';
import * as statUz from './statUzApi';

// Export types
export * from './types';

// Re-export as namespaced objects
export const worldBankApi = worldBank;
export const imfApi = imf;
export const fxApi = fx;
export const cbuApi = cbu;
export const adbApi = adb;
export const unctadApi = unctad;
export const statUzApi = statUz;

// Export default instances for convenience
export { default as WorldBankAPI } from './worldBankApi';
export { default as IMFAPI } from './imfApi';
export { default as FXAPI } from './fxApi';
export { default as CBUAPI } from './cbuApi';
export { default as ADBAPI } from './adbApi';
export { default as UNCTADAPI } from './unctadApi';
export { default as StatUzAPI } from './statUzApi';
